import React from 'react';
import { motion } from 'framer-motion';
export function Solution() {
  return <section id="solution" className="py-24 bg-stone-900 text-stone-50" data-id="element-1188">
      <div className="max-w-6xl mx-auto px-6" data-id="element-1189">
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-1190">
          <p className="font-mono text-xs uppercase tracking-widest text-stone-400 mb-6" data-id="element-1191">
            The Solution
          </p>

          <h2 className="font-serif text-4xl md:text-5xl tracking-tight leading-[1.1] text-stone-50 mb-6 max-w-3xl" data-id="element-1192">
            From email chaos to instant infrastructure
          </h2>

          <p className="text-lg text-stone-400 leading-relaxed mb-16 max-w-2xl" data-id="element-1193">
            BlockQuote replaces the entire manual quoting workflow with
            real-time infrastructure. What took days now takes seconds.
          </p>

          {/* Workflow Diagram */}
          <div className="border border-stone-700" data-id="element-1194">
            {/* Header */}
            <div className="grid grid-cols-2 border-b border-stone-700" data-id="element-1195">
              <div className="p-4 border-r border-stone-700" data-id="element-1196">
                <p className="font-mono text-xs uppercase tracking-widest text-stone-500" data-id="element-1197">
                  Before: Manual Process
                </p>
              </div>
              <div className="p-4" data-id="element-1198">
                <p className="font-mono text-xs uppercase tracking-widest text-stone-500" data-id="element-1199">
                  After: BlockQuote
                </p>
              </div>
            </div>

            {/* Step 1 */}
            <div className="grid grid-cols-2 border-b border-stone-700" data-id="element-1200">
              <div className="p-6 border-r border-stone-700" data-id="element-1201">
                <div className="flex items-start gap-4" data-id="element-1202">
                  <span className="font-mono text-xs text-stone-500 mt-1" data-id="element-1203">
                    01
                  </span>
                  <div data-id="element-1204">
                    <p className="text-stone-300 font-medium mb-1" data-id="element-1205">
                      Email RFP received
                    </p>
                    <p className="text-sm text-stone-500" data-id="element-1206">
                      Unstructured data, manual parsing required
                    </p>
                  </div>
                </div>
              </div>
              <div className="p-6 bg-stone-800/50" data-id="element-1207">
                <div className="flex items-start gap-4" data-id="element-1208">
                  <span className="font-mono text-xs text-red-600 mt-1" data-id="element-1209">
                    01
                  </span>
                  <div data-id="element-1210">
                    <p className="text-stone-50 font-medium mb-1" data-id="element-1211">
                      Instant quote request
                    </p>
                    <p className="text-sm text-stone-400" data-id="element-1212">
                      Structured input, real-time pricing
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Step 2 */}
            <div className="grid grid-cols-2 border-b border-stone-700" data-id="element-1213">
              <div className="p-6 border-r border-stone-700" data-id="element-1214">
                <div className="flex items-start gap-4" data-id="element-1215">
                  <span className="font-mono text-xs text-stone-500 mt-1" data-id="element-1216">
                    02
                  </span>
                  <div data-id="element-1217">
                    <p className="text-stone-300 font-medium mb-1" data-id="element-1218">
                      Manual pricing lookup
                    </p>
                    <p className="text-sm text-stone-500" data-id="element-1219">
                      Check PMS, spreadsheets, rate cards
                    </p>
                  </div>
                </div>
              </div>
              <div className="p-6 bg-stone-800/50" data-id="element-1220">
                <div className="flex items-start gap-4" data-id="element-1221">
                  <span className="font-mono text-xs text-red-600 mt-1" data-id="element-1222">
                    02
                  </span>
                  <div data-id="element-1223">
                    <p className="text-stone-50 font-medium mb-1" data-id="element-1224">
                      Auto-generated packages
                    </p>
                    <p className="text-sm text-stone-400" data-id="element-1225">
                      Good / Better / Best within policy
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Step 3 */}
            <div className="grid grid-cols-2 border-b border-stone-700" data-id="element-1226">
              <div className="p-6 border-r border-stone-700" data-id="element-1227">
                <div className="flex items-start gap-4" data-id="element-1228">
                  <span className="font-mono text-xs text-stone-500 mt-1" data-id="element-1229">
                    03
                  </span>
                  <div data-id="element-1230">
                    <p className="text-stone-300 font-medium mb-1" data-id="element-1231">
                      48–72 hour response
                    </p>
                    <p className="text-sm text-stone-500" data-id="element-1232">
                      Back-and-forth negotiation via email
                    </p>
                  </div>
                </div>
              </div>
              <div className="p-6 bg-stone-800/50" data-id="element-1233">
                <div className="flex items-start gap-4" data-id="element-1234">
                  <span className="font-mono text-xs text-red-600 mt-1" data-id="element-1235">
                    03
                  </span>
                  <div data-id="element-1236">
                    <p className="text-stone-50 font-medium mb-1" data-id="element-1237">
                      Instant hold + proposal
                    </p>
                    <p className="text-sm text-stone-400" data-id="element-1238">
                      Inventory secured, terms standardized
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Step 4 */}
            <div className="grid grid-cols-2" data-id="element-1239">
              <div className="p-6 border-r border-stone-700" data-id="element-1240">
                <div className="flex items-start gap-4" data-id="element-1241">
                  <span className="font-mono text-xs text-stone-500 mt-1" data-id="element-1242">
                    04
                  </span>
                  <div data-id="element-1243">
                    <p className="text-stone-300 font-medium mb-1" data-id="element-1244">
                      Lost groups + leakage
                    </p>
                    <p className="text-sm text-stone-500" data-id="element-1245">
                      No audit trail, margin captured by wholesalers
                    </p>
                  </div>
                </div>
              </div>
              <div className="p-6 bg-stone-800/50" data-id="element-1246">
                <div className="flex items-start gap-4" data-id="element-1247">
                  <span className="font-mono text-xs text-red-600 mt-1" data-id="element-1248">
                    04
                  </span>
                  <div data-id="element-1249">
                    <p className="text-stone-50 font-medium mb-1" data-id="element-1250">
                      One-click contract
                    </p>
                    <p className="text-sm text-stone-400" data-id="element-1251">
                      Direct booking, full audit trail, zero leakage
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Summary row */}
            <div className="grid grid-cols-2 border-t border-stone-700" data-id="element-1252">
              <div className="p-6 border-r border-stone-700" data-id="element-1253">
                <p className="font-mono text-sm text-stone-500" data-id="element-1254">
                  Result:{' '}
                  <span className="text-stone-300" data-id="element-1255">
                    Days of delay, margin loss
                  </span>
                </p>
              </div>
              <div className="p-6 bg-stone-800/50" data-id="element-1256">
                <p className="font-mono text-sm text-stone-400" data-id="element-1257">
                  Result:{' '}
                  <span className="text-red-600" data-id="element-1258">
                    Seconds to quote, direct revenue
                  </span>
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}